module.exports = __webpack_public_path__ + "img/aboutus.3cd86916.png";